import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";
import { getStorage } from "firebase/storage";

// Juancho, pega aquí las credenciales exactas del Firebase de Kokimiko
const firebaseConfig = {
  apiKey: "AIzaSyALS5lm4vLMfhdK7TImHKJZfpmFKId_ZPQ",
  authDomain: "kokimiko-3e432.firebaseapp.com",
  projectId: "kokimiko-3e432",
  storageBucket: "kokimiko-3e432.firebasestorage.app",
  messagingSenderId: "335747579961",
  appId: "1:335747579961:web:533006478fa66793e10de8",
  measurementId: "G-RPNJZYZP4R"
};

const app = initializeApp(firebaseConfig);
const db = getFirestore(app);
const auth = getAuth(app);
const storage = getStorage(app);

export { db, auth, storage };